import Axios from 'axios'
import store from '../store'
import strings from '@/strings'

const user = {
  getClientId () {
    return store.getters['Client/clientId']
  },
  searchUsers (search) {
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/users/search?searchFilter=${search}`)
  },
  searchUserWithTeamManagerValidation (search) {
    return Axios.get(`api/${strings.apiVersion.public}/clients/${this.getClientId()}/users/user-search?searchFilter=${search}&amount=5`)
  }
}
export default user
